module.exports = __webpack_public_path__ + "img/not-view.b122be83.svg";